export default "<div class=\"alignComponentCenter\">\n    <p-breadcrumb [model]=\"breadcrumbItems\"></p-breadcrumb>\n</div>"